import { parseFirstNamed, parseLast2Mins } from "./parseFullOdds";

export const parseSnapOdds = ( content, message, topicInfo) => {
    let pmPool;
    pmPool = content.meeting.pmPools.filter(x => x.oddsType===topicInfo.oddsType && x.leg.races[0]===topicInfo.raceNo)[0];
    if(content.page == "PWIN" && topicInfo.oddsType=="WIN" && pmPool){
        if(topicInfo.snapType === '1stboost'){
            let pwin0Pool = content.meeting.pmPools.find(x => x.oddsType=== 'PWIN0' && x.leg.races[0]===topicInfo.raceNo) 
            if(pwin0Pool != null){
                parseFirstNamed(pwin0Pool,message);
            }else{
                pwin0Pool = JSON.parse(JSON.stringify(pmPool));
                pwin0Pool.id = pwin0Pool.id.replace("WIN", "PWIN0");
                pwin0Pool.oddsType = "PWIN0";
                parseFirstNamed(pwin0Pool,message);
                content.meeting.pmPools.push(pwin0Pool);
            }
        }else if(topicInfo.snapType === 'slide2m'){
            let pwin1Pool = content.meeting.pmPools.filter(x => x.oddsType==="PWIN1" && x.leg.races[0]===topicInfo.raceNo)[0];
            if ( pwin1Pool!=null ) {
                parseLast2Mins(pwin1Pool,message);
            } else{
                pwin1Pool = JSON.parse(JSON.stringify(pmPool));
                pwin1Pool.id = pwin1Pool.id.replace("WIN", "PWIN1");
                pwin1Pool.oddsType = "PWIN1";
                parseLast2Mins(pwin1Pool,message);
                content.meeting.pmPools.push(pwin1Pool);
            }
        }
    }
}